<template>
    <div>
        <div class="tabs_content">
            <ul>
                <li @click="orderjump(1)">最近购买的商品</li>
                <li @click="orderjump(2)">收藏的商品</li>
                <li class="active">看过的商品</li>
            </ul>
        </div>
        <!-- 商品列表 -->
        <goodsList ref="goodslist" :type="type" :goodslistinfo="goodslistinfo"></goodsList>
    </div>
</template>

<script>
import api from '@/request/api.js'
import goodsList from "@/components/views/goods/goodslist.vue"
export default {
    components: {goodsList},
    data() {
        return {
            type: 2, // 商品列表组件类型 0 商品列表 1 收藏的商品 2 看过的商品
            goodslistinfo: { // 商品列表组件信息
                goodsliststyle: 2, // 商品列表样式
            }
        }
    },
    methods: {
        orderjump (sign) { // 跳转页面
            let link
            if (sign == 1) {
                link = '/Replenish'
            } else if (sign == 2) {
                link = '/Collection'
            } else {
                link = '/Seen'
            }
            this.$router.push(link)
        },
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/views/goods/seen.vue